import React from 'react';
import classes from "./ContactUs.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ContactUs = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("23")}</h2>


                </div>

                <p className={classes.contact_text}>
                    {t("25")}
                </p>

                <a href='tel:8787' className={classes.contact_btn}>
                    <FaPhone className={classes.mail_icon} /> 8787
                </a>

                <a
                    href="https://wa.me/237650528787"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.contact_btn}>
                    <FaWhatsapp className={classes.mail_icon} style={{scale:1.2}} /> 650528787
                </a>

                {/* <a href="mailto:****" className={classes.contact_btn} style={{ marginTop: "-6px" }}>
                    <FaEnvelope className={classes.mail_icon} /> ****
                </a> */}
            </div>
            <BottomNavbar active={4} />
        </>
    )
}

export default ContactUs;